
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.268 15a1 1 0 011 1v3a3 3 0 003 3h2.476a3 3 0 003-3V5a3 3 0 00-3-3h-2.476a3 3 0 00-3 3v3a1 1 0 01-2 0V5a5.006 5.006 0 015-5h2.476a5.006 5.006 0 015 5v14a5.006 5.006 0 01-5 5h-2.476a5.006 5.006 0 01-5-5v-3a1 1 0 011-1z","data-original":"#000000"}}),_c('path',{attrs:{"d":"M.877 9.879l4.586-4.586a1 1 0 111.414 1.414L2.615 10.97l15.13.03a1 1 0 010 2l-15.189-.031 4.323 4.324a1 1 0 11-1.414 1.414L.88 14.121a3 3 0 01-.002-4.242z","data-original":"#000000"}})])
          )
        }
      }
    